import * as React from "react";

function SvgExternalLink(props) {
  return (
    <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
      <path d="M16 16H2.00002V2H8.00002C8.5523 2 9.00002 1.55228 9.00002 1C9.00002 0.447715 8.5523 0 8.00002 0H2.00002C0.890015 0 1.52588e-05 0.9 1.52588e-05 2V16C1.52588e-05 17.1 0.890015 18 2.00002 18H16C17.1 18 18 17.1 18 16V10C18 9.44771 17.5523 9 17 9C16.4477 9 16 9.44771 16 10V16ZM12 0C11.4477 0 11 0.447715 11 1C11 1.55228 11.4477 2 12 2H14.59L5.46501 11.125C5.07565 11.5144 5.07565 12.1456 5.46502 12.535C5.85438 12.9244 6.48565 12.9244 6.87502 12.535L16 3.41V6C16 6.55229 16.4477 7 17 7C17.5523 7 18 6.55228 18 6V0H12Z" />
    </svg>
  );
}

export default SvgExternalLink;
